import React, { useEffect, useContext } from 'react';
import { Link } from "@react-navigation/web";
import { FormattedMessage, IntlContext } from 'react-intl';
import { currentLang, currentLangParam } from '../../components/components/utils';
import AppContext from '../../components/AppContext';
import { Auth } from 'aws-amplify';
import PopupLink from '../../templates/PopupLink';

function Menu({ navigation }) {
	const appContext = useContext(AppContext);
	const { messages } = useContext(IntlContext);

	useEffect(() => {
		async function checkAuthentication() {
			appContext.setGlobalSpinnerCount(appContext.globalSpinnerCount + 1);
			await Auth.currentAuthenticatedUser().then(() => {
				localStorage.setItem("activeKey", "Menu")
				navigation.navigate("Callback", currentLangParam());
			}).catch((error) => {
				setTimeout(() => {appContext.setFlashNotice({duration:-1, messages: [messages["mainMenu.notLoggedIn.message"]]})}, 0);
			}).finally(() => {
				appContext.setGlobalSpinnerCount(Math.max(appContext.globalSpinnerCount - 1, 0));
			});
		}
		if (!appContext.existingUser) {
			checkAuthentication();
		}
	}, []);

	return (
		<>
		  <div className="container">
		    <div className="row profile">
		      <div className="col-md-12">
		        <p><FormattedMessage id="login.introParagraph.1"/></p>
		        <p><FormattedMessage id="login.introParagraph.2" values={{i: chunks => <i>{chunks}</i>}}/></p>
		      </div>
		    </div>
		    <h2 className="row col-md-12"><FormattedMessage id="main-menu.account"/></h2>
		    <div className="row col-md-12">
		      <div className="well well-sm col-lg-9 col-md-8">
				<Link routeName="Callback" params={currentLangParam()}>
					<span className="btn btn-call-to-action link-btn"
						onClick={()=>localStorage.setItem("activeKey", "Account")}
					>
						<FormattedMessage id="main-menu.account" />
					</span>
				</Link>
		        <p><FormattedMessage id="menu.account.paragraph"/></p>
		      </div>
		    </div>
		    <h2 className="row col-md-12"><FormattedMessage id="sima.btn.efiling"/></h2>
		    <div className="row col-md-12">
		      <div className="well well-sm col-lg-9 col-md-8">
		        {/* <span className="btn btn-call-to-action link-btn" onClick={()=>localStorage.setItem("activeKey", "SecureEFilingSplash")}><Link routeName="Callback" params={currentLangParam()}><FormattedMessage id="sima.btn.efiling" /></Link></span> */}
		        <Link routeName="Callback" params={currentLangParam()}>
					<span className="btn btn-call-to-action link-btn"
						onClick={() => localStorage.setItem("activeKey", "SecureEFilingSplash")}
					>
						<FormattedMessage id="sima.btn.efiling" />
					</span>
				</Link>
				<p><FormattedMessage id="menu.secureEFiling.paragraph"/></p>
		      </div>
		    </div>
			<h2><FormattedMessage id="menu.exhibitLists.header"/></h2>
		    <div className="row profile">
		      <div className="col-md-12">
		        <p><FormattedMessage id="menu.exhibitLists" values={{a: (chunks) => <a href={window.env["cbsa-sima-breadcrumbs-url"][currentLang()]}>{chunks}</a>}}/></p>
		      </div>
		    </div>
		  </div>
		</>
	);

}

Menu.path = "";
Menu.navigationOptions = {
	pageTitle: <FormattedMessage id="menu.title"/>
	, breadcrumb: [
		<PopupLink url={window.env["canada-url"][currentLang()]}><FormattedMessage id="breadcrumb.Canada.text" /></PopupLink>
		, <PopupLink url={window.env["cbsa-breadcrumbs-url"][currentLang()]}><FormattedMessage id="breadcrumb.CBSA.text" /></PopupLink>
		, <PopupLink url={window.env["cbsa-sima-breadcrumbs-url"][currentLang()]}><FormattedMessage id="breadcrumb.ACE.text" /></PopupLink>

	]
	, breadcrumbTitle: <FormattedMessage id="breadcrumbs.menu"/>
};

export default Menu;